(function () {
  'use strict';

  const HERO_SELECTOR = '[data-hpg-band-setups-reveal]';
  const ITEM_SELECTOR = '[data-hpg-band-setups-item-reveal]';
  const VISIBLE_CLASS = 'is-visible';

  function reveal(element) {
    element.classList.add(VISIBLE_CLASS);
  }

  function setupObserver(elements, options) {
    if (!elements.length) return;

    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      elements.forEach(reveal);
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          reveal(entry.target);
          observer.unobserve(entry.target);
        });
      },
      options
    );

    elements.forEach((element) => observer.observe(element));
  }

  function setup(container) {
    setupObserver(Array.from(container.querySelectorAll(HERO_SELECTOR)), {
      rootMargin: '0px 0px -18% 0px',
      threshold: 0.35,
    });

    setupObserver(Array.from(container.querySelectorAll(ITEM_SELECTOR)), {
      rootMargin: '0px 0px 18% 0px',
      threshold: 0.01,
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => setup(document));
  } else {
    setup(document);
  }

  document.addEventListener('shopify:section:load', (event) => setup(event.target));
})();
